import { HoursBookedAvailabilityReq, WorkshopService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';

export const useWorkshopCreateHoursBookedAvailabilitiesMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof WorkshopService.postWorkshopHoursBookedAvailabilities>>,
      QueryError,
      HoursBookedAvailabilityReq,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation((input: HoursBookedAvailabilityReq) => WorkshopService.postWorkshopHoursBookedAvailabilities(input), {
    ...options
  });
